"use client"

import type { PropsWithChildren } from "react"
import { clsx } from "clsx"

import type { Nullish, PropsWithClassName } from "~/@types/generics"
import Icon from "~/components/abstracts/Icon"
import { DrawerClose, DrawerTitle } from "~/components/shared/Drawer/index.client"

import * as css from "./styles.css"

export function DrawerHeader({
  className,
  children,
  title,
}: PropsWithClassName<PropsWithChildren<{ title?: Nullish<string | JSX.Element> }>>) {
  return (
    <header className={clsx(css.DrawerHeader({ withTitle: Boolean(title) }), className)}>
      {title && (
        <DrawerTitle asChild>
          <p>
            {title}
            {children}
          </p>
        </DrawerTitle>
      )}
      <DrawerClose className={css.close}>
        <Icon name="Close" width={14} />
      </DrawerClose>
    </header>
  )
}
